import { useSvgIdPrefix } from "./useSvgIdPrefix"

import type { SVGProps } from "react"

const OUTLINE =
  "M2.25 0C1.00734 0 0 1.00745 0 2.25V38.25C0 39.4926 1.00734 40.5 2.25 40.5H22.6595C23.7513 48.1327 30.3154 54 38.25 54C46.9485 54 54 46.9484 54 38.25C54 33.9587 52.2836 30.0679 49.5 27.2274V2.25C49.5 1.00745 48.4927 0 47.25 0H2.25Z"
const CIRCLE =
  "M38.25 54C46.9485 54 54 46.9485 54 38.25C54 29.5515 46.9485 22.5 38.25 22.5C29.5515 22.5 22.5 29.5515 22.5 38.25C22.5 46.9485 29.5515 54 38.25 54Z"
const TILE = "M15.75 14.625H4.5V21.375H15.75V14.625Z"

export const AzureBoardsLogoSVG = (props: SVGProps<SVGSVGElement>) => {
  const prefix = useSvgIdPrefix()
  const maskId = `${prefix}-azure-boards-mask`
  const circleBlurId = `${prefix}-azure-boards-circle-blur`
  const tileBlurId = `${prefix}-azure-boards-tile-blur`
  const sheenId = `${prefix}-azure-boards-sheen`

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 54 54"
      fill="none"
      data-testid="azure-boards-logo"
      {...props}
    >
      <mask
        id={maskId}
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="54"
        height="54"
      >
        <path d={OUTLINE} fill="white" />
      </mask>
      <g mask={`url(#${maskId})`}>
        <path
          d="M0 2.25C0 1.00736 1.00736 0 2.25 0H47.25C48.4926 0 49.5 1.00736 49.5 2.25V38.25C49.5 39.4926 48.4926 40.5 47.25 40.5H2.25C1.00736 40.5 0 39.4926 0 38.25V2.25Z"
          fill="#008D75"
        />
        <g filter={`url(#${circleBlurId})`}>
          <path d={CIRCLE} fill="#007D5F" />
        </g>
        <path d={CIRCLE} fill="#16C8AA" />
        <path
          d="M49.5 27.2274V38.25C49.5 39.4926 48.4926 40.5 47.25 40.5H22.6595C22.5544 39.765 22.5 39.0141 22.5 38.25C22.5 29.5516 29.5515 22.5 38.25 22.5C42.6571 22.5 46.6413 24.31 49.5 27.2274Z"
          fill="#00B294"
        />
        <path d="M30.375 4.5H19.125V11.25H30.375V4.5Z" fill="#00B294" />
        <path d="M45 4.5H33.75V11.25H45V4.5Z" fill="#00B294" />
        <path d="M30.375 14.625H19.125V21.375H30.375V14.625Z" fill="#00B294" />
        <path d="M15.75 24.75H4.5V31.5H15.75V24.75Z" fill="#00B294" />
        <path d="M15.75 4.5H4.5V11.25H15.75V4.5Z" fill="#00B294" />
        <path d="M30.375 4.5H19.125V11.25H30.375V4.5Z" fill="#35D6BB" />
        <g filter={`url(#${tileBlurId})`}>
          <path d={TILE} fill="#00654C" />
        </g>
        <path d={TILE} fill="#72F8E1" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M49.4032 33.6537L36.5622 46.4947L28.2212 38.1537L31.4032 34.9717L36.5622 40.1307L46.2212 30.4717L49.4032 33.6537Z"
          fill="#C6FDF4"
        />
        <path opacity="0.25" d={OUTLINE} fill={`url(#${sheenId})`} />
      </g>
      <defs>
        <filter
          id={circleBlurId}
          x="18"
          y="18"
          width="40.5"
          height="40.5"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur stdDeviation="2.25" />
        </filter>
        <filter
          id={tileBlurId}
          x="0"
          y="10.125"
          width="20.25"
          height="15.75"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur stdDeviation="2.25" />
        </filter>
        <linearGradient
          id={sheenId}
          x1="54"
          y1="0"
          x2="54"
          y2="54"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  )
}
